import { deleteSkill, ISkill } from "@/api/skills";
import { DestructiveDialog } from "@/components/shared/dialogs/destructive-dialog/DestructiveDialog";
import { DestructiveDialogProps } from "@/components/shared/dialogs/destructive-dialog/DestructiveDialog.types";
import { Button } from "@/components/ui/button";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";
import { useQueryClient } from "@tanstack/react-query";
import { useDialogs } from "@toolpad/core";
import { Trash2 } from "lucide-react";

interface IProps {
    skillId: number;
    status: ISkill["status"];
}

export const DeleteSkillButton = ({ skillId, status }: IProps) => {
    const dialogs = useDialogs();
    const queryClient = useQueryClient();

    const dialogProps: DestructiveDialogProps = {
        itemId: skillId,
        subject: "skill",
        mutationFn: deleteSkill,
        customDescription:
            status === "active"
                ? "This skill is currently published and may be in use by agents. Are you sure you want to delete it?"
                : undefined,
        onSucceeded: () => {
            queryClient.invalidateQueries({
                queryKey: ["admin-skills"],
            });
        },
    };

    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger
                    render={
                        <Button
                            variant="ghost"
                            size="icon"
                            className="text-muted-foreground hover:text-destructive size-8"
                            onClick={() =>
                                dialogs.open(DestructiveDialog, dialogProps)
                            }
                        />
                    }
                >
                    <Trash2 className="size-4" />
                    <span className="sr-only">Delete</span>
                </TooltipTrigger>
                <TooltipContent>Delete Skill</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};
